import React from "react"
import MyUIHelpers from "src/core/components/MyUI/MyUIHelpers"

const MyUIAvatar = React.lazy(() => import("./Types/Avatar"))
const MyUICreateTaskForm = React.lazy(() => import("./Types/CreateTaskForm"))
const MyUIStatisticalTask = React.lazy(() => import("./Types/StatisticalTask"))
const MyUISimpleTable = React.lazy(() => import("./Types/SimpleTableV2"))
const MyUIPreviewFile = React.lazy(() => import("./Types/PreviewFile"))
const MyUITaskDetail = React.lazy(() => import("./Types/TaskDetail"))
const MyUIPreviewTask = React.lazy(() => import("./Types/PreviewTask"))
const MyUIFilter = React.lazy(() => import("./Types/Filter"))
const MyUITaskList = React.lazy(() => import("./Types/TaskList"))
const MyUIPagination = React.lazy(() => import("./Types/Pagination"))
const MyUICreateCommunication = React.lazy(
  () => import("./Types/CreateCommunication")
)
const MyUIStatisticalTaskV2 = React.lazy(
  () => import("./Types/StatisticalTaskV2")
)
const MyUIEmptyData = React.lazy(() => import("./Types/EmptyData"))
const MyUICommunicationDetail = React.lazy(
  () => import("./Types/CommunicationDetail")
)
const MyUICommunicationList = React.lazy(
  () => import("./Types/CommunicationList")
)
const MyUICommunicationView = React.lazy(
  () => import("./Types/CommunicationView")
)
const MyUIMultiView = React.lazy(() => import("./Types/MultiView"))
const MyUIStatisticalTabs = React.lazy(() => import("./Types/StatisticalTabs"))
const MyUINotificationList = React.lazy(
  () => import("./Types/NotificationList")
)
const MyUIMsgError = React.lazy(() => import("./Types/MsgError"))
const MyUIButtonHeader = React.lazy(() => import("./Types/ButtonHeader"))
const MyUIViewMode = React.lazy(() => import("./Types/ViewMode"))
const MyUICopyToFlipboard = React.lazy(() => import("./Types/CopyToClipboard"))
const MyBottomToast = React.lazy(() => import("./Types/BottomToast"))
const MyUIToastMsg = React.lazy(() => import("./Types/ToastMsg"))
const MyUIBlockTaskList = React.lazy(() => import("./Types/BlockTaskList"))
const MyUITaskRelation = React.lazy(() => import("./Types/TaskRelation"))
const MyUIChecklist = React.lazy(() => import("./Types/Checklist"))
const MyUITodoInput = React.lazy(() => import("./Types/TodoInput"))
const MyUIGuideline = React.lazy(() => import("./Types/Guideline"))
const MyUIHtml = React.lazy(() => import("./Types/Html"))
const MyUIWithMyPage = React.lazy(() => import("./Types/WithMyPage"))

/**Layout */
const MyUIGridLayout = React.lazy(() => import("./Types/Layout/grid"))
const MyUISlideLayout = React.lazy(() => import("./Types/Layout/slide"))
const MyListLayout = React.lazy(() => import("./Types/Layout/list"))
const MyUIWrapContent = React.lazy(() => import("./Types/WrapContent"))
const MyListDNDLayout = React.lazy(() => import("./Types/Layout/list_dnd"))

/**Card */
const MyUIOneCommunication = React.lazy(
  () => import("./Types/OneCommunication")
)
const MyUIOneCommunicationInSlide = React.lazy(
  () => import("./Types/OneCommunicationInSlide")
)
const MyUICommunicationAcknowledge = React.lazy(
  () => import("./Types/CommunicationAcknowledge")
)
const MyUIOneNotificationTask = React.lazy(
  () => import("./Types/OneNotification")
)
const MyUIRelatedTask = React.lazy(() => import("./Types/RelatedTask"))
const MyUITodoCard = React.lazy(() => import("./Types/TodoCard"))
const MyUIProgressBar = React.lazy(() => import("./Types/ProgressBar"))

const List = {
  avatar: MyUIAvatar,
  create_task_form: MyUICreateTaskForm,
  statistical_task: MyUIStatisticalTask,
  simple_table: MyUISimpleTable,
  preview_file: MyUIPreviewFile,
  task_detail: MyUITaskDetail,
  preview_task: MyUIPreviewTask,
  filter: MyUIFilter,
  task_list: MyUITaskList,
  pagination_data: MyUIPagination,
  create_communicaton: MyUICreateCommunication,
  statistical_task_v2: MyUIStatisticalTaskV2,
  empty_data: MyUIEmptyData,
  communicaton_detail: MyUICommunicationDetail,
  communication_list: MyUICommunicationList,
  communication_view: MyUICommunicationView,
  multi_view: MyUIMultiView,
  statistical_tabs: MyUIStatisticalTabs,
  notification_list: MyUINotificationList,
  msg_error: MyUIMsgError,
  bottom_toast: MyBottomToast,
  toast_msg: MyUIToastMsg,
  button_header: MyUIButtonHeader,
  view_mode: MyUIViewMode,
  copy_to_clipboard: MyUICopyToFlipboard,
  block_task_list: MyUIBlockTaskList,
  task_relation: MyUITaskRelation,
  checklist: MyUIChecklist,
  progress_bar: MyUIProgressBar,
  todo_input: MyUITodoInput,
  guideline: MyUIGuideline,
  html: MyUIHtml,
  with_mypage: MyUIWithMyPage,
  /**Layout */
  grid_layout: MyUIGridLayout,
  slide_layout: MyUISlideLayout,
  list_layout: MyListLayout,
  wrap_content: MyUIWrapContent,
  list_dnd_layout: MyListDNDLayout,
  /**Card */
  communication_in_grid: MyUIOneCommunication,
  communication_in_slide: MyUIOneCommunicationInSlide,
  communication_acknowledge: MyUICommunicationAcknowledge,
  notification_task: MyUIOneNotificationTask,
  related_task: MyUIRelatedTask,
  todo_card: MyUITodoCard,
}
const MyUIOne = {
  init() {
    MyUIHelpers.addTypesFromListLazy(List)
  },
}

export default MyUIOne
